module.exports = __webpack_public_path__ + "static/media/ConfettiAnimation.50d37c56.gif";